// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { xBaseTheme } from "@stoneage/XDL/types";

export default {
    primary: {
        main: "#df1e27",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#000000",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#333F48",
        accent: "#F8F9FA",
        accentContrast: "#333F48",
        border: "#CCCCCC",
        disabled: "#EBEBEB",
        ui1: "#000000",
        ui2: "#DF1E27",
        ui3: "#ffffff",
        ui4: "#F3F3F3",
        ui5: "#cccccc",
        ui6: "#999999",
        ui7: "#666666",
        ui8: "#4d4d4d",
        ui9: "#333333",
        ui10: "#262626",
        ui11: "#1a1a1a",
        ui12: "#AA141B",
        ui13: "#DF1E27",
        ui14: "#09273E",
        ui15: "#607D8B",
        ui16: "#045d56",
        ui17: "#0a273e",
        ui18: "#607d8b",
        ui19: "#979797",
        ui20: "#109FEA",
        ui21: "#D8D8D8",
        white: "#ffffff",
        black: "#000000",
    },
    text: {
        main: "#4D4D4D",
        disabled: "#475353",
        accent: "#2D3435",
        link: "#DF1E27",
    },
    success: {
        main: "#00A65A",
        light: "#D9F2E7",
        contrast: "#FFFFFF",
    },
    danger: {
        main: "#E4104E",
        light: "#FBDBE5",
        contrast: "#FFFFFF",
    },
    warning: {
        main: "#AC8613",
        light: "#FDF9DE",
        contrast: "#FFFFFF",
    },
    info: {
        main: "#53ACDB",
        light: "#DDEEF8",
        contrast: "#FFFFFF",
    },
    transparent: {
        main: "transparent",
        light: "#DDEEF8",
        contrast: "#424242",
    },
} as xBaseTheme["colors"];
